/**
 * SizilPro — useCurrentClient
 * Loads the active client record into clientStore when clientId is known.
 * Call once near the app root; anywhere else just read from clientStore.
 */

import { useEffect } from "react";
import { useAuthStore }   from "@/store/authStore";
import { useClientStore, type Client } from "@/store/clientStore";

export function useCurrentClient(): { client: Client | null; isLoading: boolean } {
  const clientId = useAuthStore((s) => s.clientId);
  const client   = useClientStore((s) => s.client);
  const isLoading = useClientStore((s) => s.isLoading);
  const fetch    = useClientStore((s) => s.fetchClient);

  useEffect(() => {
    if (clientId && !client) {
      fetch(clientId);
    }
  }, [clientId, client, fetch]);

  return { client, isLoading };
}
